export default "__VITE_ASSET__CR30OOkD__"